'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

export default function ImageWithFallback(imageProps: ImageProps & { fallbackSrc: string }) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  if (error) {
    return (
      <Image
        src={imageProps.fallbackSrc}
        alt={'fallback'}
        width={imageProps.width}
        height={imageProps.height}
        className={imageProps.className}
        priority={true}
      />
    );
  } else {
    return (
      <>
        {loading && (
          <div
            className={`skeleton-item rounded-6pxr ${imageProps.className}`}
            style={{
              aspectRatio: `${imageProps.width}/${imageProps.height}`,
            }}
          ></div>
        )}
        <Image
          src={imageProps.src === '' ? imageProps.fallbackSrc : imageProps.src}
          alt={imageProps.alt}
          width={imageProps.width}
          height={imageProps.height}
          className={imageProps.className}
          onError={() => setError(true)}
          onLoad={() => setLoading(false)}
          style={loading ? { display: 'none' } : {}}
          priority={true}
        />
      </>
    );
  }
}
